import { render, staticRenderFns } from "./SetLanguage.vue?vue&type=template&id=3df0e0ca&scoped=true&"
import script from "./SetLanguage.vue?vue&type=script&lang=js&"
export * from "./SetLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SetLanguage.vue?vue&type=style&index=0&id=3df0e0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df0e0ca",
  null
  
)

export default component.exports